import authDictionary from "./authDictionary";
import notificationDictionary from "./notificationDictionary";
import postsDictionary from "./postsDictionary";
import userProfileDictionary from "./userProfileDictionary";
import documentDictionary from "./documentDictionary";
import eligibilityCheckDictionary from "./eligibilityCheckDictionary";
import applicantDetailsDictionary from "./applicantDetailsDictionary";
import applicationDetailsDictionary from "./applicationDetailsDictionary";
import disbursementRequestDictionary from "./disbursementRequestDictionary";
import chatDictionary from "./chatDictionary";
import loanDocumentsDictionary from "./loanDocumentsDictionary";
import supportDictionary from "./supportDictionary";

const dictionary = {
  auth: authDictionary,
  posts: postsDictionary,
  notifications: notificationDictionary,
  profile: userProfileDictionary,
  document: documentDictionary,
  eligibilityCheck: eligibilityCheckDictionary,
  applicantDetails: applicantDetailsDictionary,
  applicationDetails: applicationDetailsDictionary,
  disbursementRequest: disbursementRequestDictionary,
  chat: chatDictionary,
  loanDocuments: loanDocumentsDictionary,
  support: supportDictionary,
};

export default dictionary;
